<template>
  <div class="row">
    <div class="col">
      <div class="card card-body pt-0 mt-4 bg-light">
        <h5 class="mt-4 mb-3">Previous Versions</h5>

        <div v-if="versionsToShow.length">
          <Version
            v-for="(version, index) in versionsToShow"
            :key="index"
            :version="version"
            :type="type"
            :state="state"
          />
        </div>

        <div v-else>
          <div class="card card-body">
            <span class="card-text">
              When you make updates to a contract. The previous versions will be
              avaliable here.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@/Mixins/helpers';
import contractState from '@/Mixins/contractState';
import Version from './Version';

export default {
  mixins: [helpers, contractState],

  components: {
    Version,
  },

  props: {
    versions: Array,
    type: String,
  },

  computed: {
    versionsToShow() {
      // if (this.state.withCounterparty) {
      //   return this.versions.filter((v) => v.version.endsWith('.00'));
      // }
      return this.versions;
    },
  },
};
</script>
